(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const update = () => {
    frame = 0;
    document.querySelectorAll('.ecstatic-editorial-slider').forEach(hero => {
      const section = hero.closest('.shopify-section');
      if (!section) return;
      section.classList.toggle('ed-scroll-banner', !motion.matches);
      const rect = section.getBoundingClientRect();
      const offset = motion.matches ? 0 : Math.min(rect.height, Math.max(0, -rect.top)) * 0.65;
      hero.style.setProperty('--ed-banner-offset', `${offset}px`);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  motion.addEventListener('change', schedule);
  schedule();
})();
